import $api from "../../../services/axiosService";

import { setDailyPercentAction } from "../setDailyPercent.action";


export const getDailyPercentThunkAction = () => async (dispatch) => {
    try {
        const response = await $api("v1/manager/subordinates/leaves/overlapped");
        if (response.status === 200) {
            dispatch(setDailyPercentAction(String(response.data.percent)));
        }
    } catch (error) {
        // console.log("ERROR WHILE GETTING DAILY PERCENT: ", error.response)
    }
};
